import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";


export const getAllTCs = createAsyncThunk(
  "getAllTCs",
  async ({ TCStatus, TcStage }) => {
    const token = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/tc?stage=${TcStage}&status=${TCStatus}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getBuyerRejectedShipment = createAsyncThunk(
  "getBuyerRejectedShipment",
  async ({ shipmentStatus, TcStage }) => {
    const token = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/tc?shipmentStatus=${shipmentStatus}&&stage=${TcStage}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const assignToMe = createAsyncThunk("assignToMe", async (id, values) => {
  return toast.promise(
    new Promise(async (resolve, reject) => {
      const token = localStorage.getItem("cu_user");
      try {
        const response = await axios.patch(
          `${process.env.REACT_APP_API_HOST}/api/tc/self-assign/${id}`,
          values,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.status === "success") {
          resolve(response);
          ;
          return response?.data;
        } else {
          reject(response?.data?.message);
        }
      } catch (error) {
        reject(error?.response?.data);
      }
    }),
    {
      pending: "Assigning...",
      success: "Assigned to you successfully",
      error: {
        render({ data }) {
          return `${data?.message}`;
        },
      },
    }
  );
});

export const approveTC = createAsyncThunk(
  "approveTC",
  async ({ id, values }) => {
    const token = localStorage.getItem("cu_user");
    return toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          let response = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/tc/approve/${id}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data.status === "success") {
            resolve(response);
            ;
            return response?.data;
          } else {
            reject(response?.data?.message);
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "TC Application Approved successfully",
        error: {
          render({ data }) {
            return `${data.message}`;
          },
        },
      }
    );
  }
);

export const countForTCAdmin = createAsyncThunk("countForTCAdmin", async () => {
  try {
    const token = localStorage.getItem("cu_user");
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/tc/agg-status/count`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    ;
    return data.data;
  } catch (error) {
    console.error(error);
  }
});

export const rejectTC = createAsyncThunk("rejectTC", async ({ id, values }) => {
  return toast.promise(

    new Promise(async (resolve, reject) => {
      const token = localStorage.getItem("cu_user");
      try {
        const response = await axios.patch(
          `${process.env.REACT_APP_API_HOST}/api/tc/reject/${id}?inventory=lock`,
          values,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.status === "success") {
          resolve(response);
          ;
          return response?.data;
        } else {
          reject(response?.data?.message);
        }
      } catch (error) {
        reject(error?.response?.data);
      }
    }),
    {
      pending: "Processing...",
      success: "TC Application Rejected successfully",
      error: {
        render({ data }) {
          return `${data.message}`;
        },
      },
    }
  );
});

export const declineTC = createAsyncThunk("declineTC", async ({ id, values }) => {
  return toast.promise(

    new Promise(async (resolve, reject) => {
      const token = localStorage.getItem("cu_user");
      try {
        const response = await axios.patch(
          // inventory=lock shouldnt be included here in this api call since its for returning inventory, verified with gajendra
          `${process.env.REACT_APP_API_HOST}/api/tc/reject/${id}`,
          values,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.status === "success") {
          resolve(response);
          ;
          return response?.data;
        } else {
          reject(response?.data?.message);
        }
      } catch (error) {
        reject(error?.response?.data);
      }
    }),
    {
      pending: "Processing...",
      success: "TC Application Declined/ return inventory successfully",
      error: {
        render({ data }) {
          return `${data.message}`;
        },
      },
    }
  );
});

export const sentBackToClient = createAsyncThunk(
  "sentBackToClient",
  async ({ id, values }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const token = localStorage.getItem("cu_user");
        try {
          const res = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/tc/sendTcToClient/${id}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "TC Application sent back to client successfully",
        error: {
          render({ data }) {
            return `${data.message}`;
          },
        },
      }
    );
  }
);

export const TCL2AdminSlice = createSlice({
  name: "TCL2Admin",
  initialState: {
    allTCs: [],
    TcL2: null,
    counts: [],
    status: "idle",
    error: null,
    isloading: true,
  },
  reducers: {},
  extraReducers: {
    [getAllTCs.pending]: (state, action) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getAllTCs.fulfilled]: (state, action) => {
      state.status = "success";
      state.allTCs = action.payload;
      state.isloading = false;
    },
    [getAllTCs.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },
    [countForTCAdmin.pending]: (state, action) => {
      state.status = "pending";
      state.isloading = true;
    },
    [countForTCAdmin.fulfilled]: (state, action) => {
      state.status = "success";
      state.counts = action.payload;
      state.isloading = false;
    },
    [countForTCAdmin.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },
    [getBuyerRejectedShipment.pending]: (state, action) => {
      state.isloading = true;
      state.status = "pending";
    },
    [getBuyerRejectedShipment.fulfilled]: (state, action) => {
      state.status = "success";
      state.isloading = false;
      state.allTCs = action.payload;
    },
    [getBuyerRejectedShipment.rejected]: (state, action) => {
      state.status = "failed";
      state.isloading = true;
      state.error = action.error;
    },
  },
});

export default TCL2AdminSlice.reducer;
